import moment from 'moment';
import axios from 'axios';
import utils from './utils';

import { mapState } from 'vuex';
import { HollowDotsSpinner } from 'epic-spinners';

import companyLogo from '../assets/img/company.png';
import userImg from '../assets/img/user.png';

export default {
    components: {
        HollowDotsSpinner,
    },
    data() {
        return {
            // loading: false,
            copied: false,
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
            maxLinks: 10,
            companyLogo,
            userImg,
            savedJobs: [],
        };
    },
    filters: {
        moment: function(date) {
            return moment(date).format('MMMM Do YYYY, h:mm a');
        },
        dateOnly: function(date) {
            return moment(date).format('MMMM Do YYYY');
        },
        timeOnly: function(time) {
            return moment(time).format('h:mm a');
        },
    },
    computed: {
        ...mapState(['rates']),
    },
    methods: {
        ...utils,
        catchErrors(e) {
            //   console.log({e});
            const { response } = e;
            this.$store.commit('setLoader', false);
            if (!response)
                return this.showError('Network Error!', 'Please check your internet connection and try again');

            if (response.status === 404) return;

            const message = response.data;
            console.log({ message });
            //   if (message.includes('not valid')) return this.sessionExpired();

            return this.showError('', message.replace(/data:/g, '') || 'An error occured!');
        },
        sessionExpired() {
            localStorage.removeItem('id');
            localStorage.removeItem('token');
            window.location.href = '/login';

            const text = 'Please login again to continue using Kovatek';
            this.showNotification('warning', text, 'Session Expired!');
        },
        logout(type) {
            localStorage.removeItem('id');
            localStorage.removeItem('token');
            window.location.href = 'https://beta.kovatek.com';

            if (type) this.showToast('Expecting you soon!');
        },
        showError(message, description) {
            this.$notification.error({
                message: message || 'Error',
                description,
                class: 'error-class',
                duration: 10,
                placement: 'topRight',
                style: {
                    border: '2px solid #FC041C',
                },
            });
        },
        showToast(message) {
            this.$notification.success({
                message,
                duration: 10,
                placement: 'topRight',
                class: 'toast-class',
                style: {
                    backgroundColor: '#4bb38e',
                },
            });
        },
        showNotification(type, description, message) {
            const backgroundColor = type === 'success' ? '#4bb38e' : type == 'info' ? '#04C4FC' : '';

            this.$notification[type]({
                message,
                description,
                duration: 10,
                placement: 'topRight',
                style: backgroundColor
                    ? {
                          backgroundColor,
                      }
                    : {
                          border: '2px solid #FC041C',
                      },
            });
        },
        getAllSettings() {
            this.$store
                .dispatch('settings/userSettings')
                .then(resp => {
                    this.data = { ...resp.data };
                })
                .catch(err => {
                    if (!err.response) throw new Error('Network Error!');
                    this.catchErrors(err);
                });
        },
        // replaceNonNumerics: value => 0
    },
};
